import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import api from '@/api';
export default {
  name: 'Hand',
  data: function data() {
    return {
      list: [],
      isSelect: false,
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      selectForm: {
        matchmakerSts: null,
        handSts: null,
        registerTime: [],
        sendMember: {
          memberNo: null
        },
        receiveMember: {
          memberNo: null
        }
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  created: function created() {
    this.getPageList();
  },
  methods: {
    checkHandStsTime: function checkHandStsTime(hand) {
      if (hand.handSts === 0) {
        return this.fomatDate(hand.createTime);
      } else if (hand.handSts === 1 && hand.matchmakerSts === 0) {
        return this.fomatDate(hand.successTime);
      } else if (hand.handSts === 1 && hand.matchmakerSts === 1) {
        return this.fomatDate(hand.successTime);
      } else if (hand.handSts === 2 && hand.matchmakerSts === 0) {
        return this.fomatDate(hand.refuseTime);
      } else if (hand.handSts === 2 && hand.matchmakerSts === 2) {
        return this.fomatDate(hand.refuseTime);
      }
    },
    checkHandSts: function checkHandSts(hand) {
      if (hand.handSts === 0) {
        return '待牵手';
      } else if (hand.handSts === 1 && hand.matchmakerSts === 0) {
        return '同意牵手';
      } else if (hand.handSts === 1 && hand.matchmakerSts === 1) {
        return '对接成功';
      } else if (hand.handSts === 2 && hand.matchmakerSts === 0) {
        return '拒绝牵手';
      } else if (hand.handSts === 2 && hand.matchmakerSts === 2) {
        return '对接失败';
      }
    },
    fomatDate: function fomatDate(date) {
      if (date === null || date === '') {
        return '';
      }
      return date.replace('年', '-').replace('月', '-').replace('日', '');
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.registerTime = [];
      this.selectForm.startTime = null;
      this.selectForm.endTime = null;
      this.selectForm.sendMember.memberNo = null;
      this.selectForm.receiveMember.memberNo = null;
      this.selectForm.handSts = null;
      this.selectForm.matchmakerSts = null;
      this.getPageList();
    },
    search: function search() {
      this.pageNo = 1;
      this.getPageList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getPageList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageList();
    },
    getPageList: function getPageList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var form, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              form = {
                sendMember: {},
                receiveMember: {}
              };
              form.pageNo = _this.pageNo;
              form.pageSize = _this.pageSize;
              form.sendMember.memberNo = _this.selectForm.sendMember.memberNo;
              form.receiveMember.memberNo = _this.selectForm.receiveMember.memberNo;
              if (_this.selectForm.registerTime.length >= 2) {
                form.startTime = _this.selectForm.registerTime[0];
                form.endTime = _this.selectForm.registerTime[1];
              }
              if (_this.selectForm.handSts === 0) {
                form.handSts = 0;
                form.matchmakerSts = 0;
              } else if (_this.selectForm.handSts === 1) {
                form.handSts = 1;
                form.matchmakerSts = 0;
              } else if (_this.selectForm.handSts === 2) {
                form.handSts = 2;
                form.matchmakerSts = 0;
              } else if (_this.selectForm.handSts === 3) {
                form.handSts = 1;
                form.matchmakerSts = 1;
              } else if (_this.selectForm.handSts === 4) {
                form.handSts = 2;
                form.matchmakerSts = 2;
              }
              _context.n = 1;
              return api.GET_HAND_PAGE_LIST(form);
            case 1:
              res = _context.v;
              _this.list = res.body.datas;
              _this.pageTotal = res.body.sumDataCount;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};